import React from "react";
import Histogram from 'components/custom/Highcharts/Histogram'
import T from 'i18n-react'
import { Table, TableCell, TableRow, TableHead } from 'react-toolbox/lib/table'
import { updateChartBarRange, onChartTableLoadingEnd } from '../actions'
import { chartStateSelector } from '../selectors'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from '../styles.scss'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Flex } from 'reflexbox'
import LoadingDiv from '../LoadingDiv'

const mapStateToProps = (state) => {
  return {
    chartState: chartStateSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateBarRange: (type, start, end) => dispatch(updateChartBarRange(type, start, end)),
    tableLoadingEnd: (type) => dispatch(onChartTableLoadingEnd(type)),
  }
}

class PexDataEyeCard extends React.Component {

  updateBar = (type) => {
    return (start, end) => this.props.updateBarRange(type, start, end)
  }

  getCategories = (data) => {
    return data.map(d => d.index)
  }

  getData = (data) => {
    return data.map(d => d.count)
  }

  updateBarRange = (event) => {
    const { report } = this.props
    this.props.updateBarRange(report.type, event.point.x, event.point.x2)
  }

  getAdditionalOptions = (data) => {

    const min = Math.min(...data)
    const max = Math.max(...data)
    let binwidth = 5
    if (max - min < 20 ) binwidth = 1
    if (max - min < 40 ) binwidth = 2
    return {
      plotOptions: {
        histogram: {
          color: '#77b800',
          binWidth: binwidth,
          dataLabels: {
            enabled: true,
            formatter: function() {
              return this.y == 0 ? '' : this.y
            }
          }
        },
        series: {
          cursor: 'pointer',
          events: {
              click: (eve) => {
                if (eve.point.x == null) return
                this.updateBarRange(eve)
              }
          }
        }
      },
    }
  }

  renderProjectTable () {
    const {
      report,
      chartState,
    } = this.props
    if (!report || !report.data) return

    const pexChartState = chartState(report.type)

    const startIndex = pexChartState.selectedXStart
    const endIndex = pexChartState.selectedXEnd == startIndex ? pexChartState.selectedXEnd + 1 : pexChartState.selectedXEnd
    let tableList = [];
    for (let i = startIndex; i <= endIndex; i++) {
      const curIndexData = report.data.find(d => d.index == i)
      if (curIndexData) {

        curIndexData.projects.forEach(project => {
          const projectInTableList = tableList.find(x => x.projectId == project)
          if (!projectInTableList) {
            tableList.push({
              projectId: project,
              indices: [curIndexData.index]
            })
          } else {
            projectInTableList.indices.push(curIndexData.index)
          }
        })
      }
    }

    if (tableList.length === 0) return


    return (
      <Flex className={styles.pexTableWrapper}>
        <Table selectable={false} className={styles.compactTable}>
          <TableHead key={`head`}>
          <TableCell key={`head1`}><div className={styles.compactCell}>Project ID</div></TableCell>
          <TableCell key={`head2`}><div className={styles.compactCell}>Project Name</div></TableCell>
          <TableCell key={`head3`}><div className={styles.compactCell}>NVQual Revision #</div></TableCell>
          <TableCell key={`head4`}><div className={styles.compactCell}>Product SKU</div></TableCell>
          <TableCell key={`head5`}><div className={styles.compactCell}>Partner Site</div></TableCell>
            <TableCell key={`head6`}><div className={styles.compactCell}>Pex Data Eye Indices</div></TableCell>
          </TableHead>
            {tableList.map((row, idx) => (
              <TableRow key={`row${idx}`}>
                <TableCell key={`projectId${idx}`}><div className={styles.compactCell}><Link to={`/project/${row.projectId}/view`} target="_blank">{row.projectId}</Link></div></TableCell>
                <TableCell key={`projectName${idx}`}><div className={styles.compactCell}>{report.additionalData.find(x => row.projectId == x.projectId).projectName}</div></TableCell>
                <TableCell key={`revisionNumber${idx}`}><div className={styles.compactCell}>{report.additionalData.find(x => row.projectId == x.projectId).revisionNumber}</div></TableCell>
                <TableCell key={`sku${idx}`}><div className={styles.compactCell}>{report.additionalData.find(x => row.projectId == x.projectId).productSku}</div></TableCell>
                <TableCell key={`ps${idx}`}><div className={styles.compactCell}>{report.additionalData.find(x => row.projectId == x.projectId).partnerSiteName}</div></TableCell>
                <TableCell key={`indices${idx}`}><div className={styles.compactCell}>{row.indices.join(", ")}</div></TableCell>
              </TableRow>
            ))}
        </Table>
      </Flex>
    )
  }

  render() {
    const {
      report,
      chartState
    } = this.props

    if (!report || !report.type) return(<div></div>)

    const { chartLoading } = chartState(report.type)

    if (chartLoading) return (<LoadingDiv />)

    return (
      <div>
          <React.Fragment>
            <div className={styles.pexChart}>
              <Histogram 
              title={T.translate(`containers.report.nvqual.chartTitles.${report.type}`)} 
              xTitle={T.translate(`containers.report.nvqual.pexCharts.xAxis.${report.type}`)} 
              yTitle={T.translate(`containers.report.nvqual.pexCharts.yAxis.${report.type}`)} 
              data={report.raw.length > 0 ? report.raw : [-1]}  // https://github.com/highcharts/highcharts/issues/11388
              additionalOptions={this.getAdditionalOptions(report.raw)}/>
            </div>
            {this.renderProjectTable()}
          </React.Fragment>
      </div>
    );
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withConnect,
  withStyle,
)(PexDataEyeCard)